import { formatNumber } from "@narmi/design_system";

const magnitudes = ["", "K", "M", "B", "T", "Q"];

export function formatShortCurrency(value: string) {
  const num = Number(value);
  const abs = Math.abs(num);
  const sign = num < 0 ? "-" : "";

  if (abs < 1000) {
    return `${sign}${formatNumber(String(abs))}`;
  }

  const magnitude = Math.floor(Math.log10(abs) / 3) * 3;
  let shortValue = Math.round((abs * 10) / Math.pow(10, magnitude)) / 10;
  let magnitudeIndex = magnitude / 3;
  if (shortValue >= 1000) {
    shortValue /= 1000;
    magnitudeIndex += 1;
  }

  const safeMagnitudeIndex = Math.min(magnitudeIndex, magnitudes.length - 1);

  return `${sign}$${shortValue}${magnitudes[safeMagnitudeIndex]}`;
}
